<template>
	
	<div>
		
		<layout>

			<template v-slot:title> 
				CONFIGURACIÓN
			</template>

			<template v-slot:subtitle> 
				CONFIGURACIÓN
			</template>

			<template v-slot:content>

				<v-container id="setting">

					<v-row>

						<v-col offset-md="4" md="4" offset-sm="2" sm="8" cols="12">

							<div class="text-right mb-3">
								<v-btn light small @click="abandonarCuenta()">ABANDONAR CUENTA</v-btn>
							</div>

							<ChangePassword />
						</v-col>

					</v-row>

				</v-container>
			</template>
		</layout>

	</div>

</template>


<style>
	

</style>


<script>
	
	import Layout from './../../layout/Layout'
	import UserService from '@/shared/services/UserService'

	import ChangePassword from './components/ChangePassword'


	export default 
	{
		
		data() {
			return {
				
			}
		},

		components: {
			Layout,
			ChangePassword
		},

		methods: {

			abandonarCuenta()
			{
				SwalQuestion('', 'Al abandonar la cuenta todos tus datos se borraran y no podrás acceder nuevamente a ellos. ¿Estas seguro(a) que deseas abandonar la cuenta?', async resp =>
				{
					if(resp.isConfirmed)
					{
						const resp = await UserService.abandonarCuenta()

						SwalMixin('La cuenta ha sido abandonada exitosamente', 'success')

						this.$router.push('/')
					}
				})
			}

		}

	}

</script>